// API Configuration
const API_BASE_URL = 'https://api.leonidas.optimize-it.be'; // Change to your API base URL
//const API_BASE_URL = 'http://localhost:3005'; // Change to your API base URL

// Helper function for authenticated API calls
export const apiCall = async (endpoint, options = {}) => {
    const defaultHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('accesstoken'),
        'X-Year': localStorage.getItem('year') || '2026'
    };

    const config = {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers
        }
    };

    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    return response;
};

// Export base URL for non-authenticated calls (like login)
export const API_URL = API_BASE_URL;
